"use strict";

import * as THREE from "three";
import { Presets } from "./lib/Presets";
import { Views } from "./lib/Views";

class Garden extends THREE.Group {
    static Presets = Presets;
    static Views = Views;

    clock: THREE.Clock = new THREE.Clock();

    patternTriangleUrl = new URL('./assets/textures/patternTriangle.png', import.meta.url).toString();
    patternCircleUrl = new URL('./assets/textures/patternCircle.png', import.meta.url).toString();

    views = [];

    constructor() {
        super();

        // console.log(Presets);
        // let bloomView = new Views.BloomView();
        // this.add(bloomView);
        // this.views.push(bloomView);

        // let geometryView = new Views.GeometryView(

        //     {
        //         modelUrl: new URL("./assets/DomeFacade.obj", import.meta.url).toString(),
        //         maxBloomRadius: .32,
        //         minBloomRadius: .08,
        //         minSurfaceOffset: .04,
        //         maxSurfaceOffset: .24,
        //         textureScale: 4
        //     }

        //     // {
        //     //     modelUrl: new URL("./assets/Circle.obj", import.meta.url).toString(),
        //     //     maxBloomRadius: .125,
        //     //     minBloomRadius: .03,
        //     //     minSurfaceOffset: .05,
        //     //     maxSurfaceOffset: .15,
        //     //     textureScale: 16
        //     // }

        // );
        // this.add(geometryView);
        // this.views.push(geometryView);

        // let randomView = new Views.RandomView();
        // this.add(randomView);

        // let arrangementView = new Views.ArrangementView();
        // this.add(arrangementView);
        // this.views.push(arrangementView);
    }

    generate() {
        this.views.forEach((view) => {
            if (view.visible) view.generate?.();
        });
    }

    progress(value) {
        this.views.forEach((view) => {
            if (view.visible) view.progress?.(value);
        });
    }

    click(mouse, camera) {
        this.views.forEach((view) => {
            if (view.visible) view.click?.(mouse, camera);
        });
    }

    update() {
        let time = this.clock.getElapsedTime();

        this.views.forEach((view) => {
            if (view.visible) view.update?.(time);
        });
    }
}

export default Garden;